import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class ReadOnlyParamCommand extends AbstractConfDataCommand {
  confValueId: number;
  paramValueId?: number;
}